import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notifications = () => {
    const base_url = process.env.REACT_APP_BASE_URL;

    const [notifications, setNotifications] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)
    const [sortOrder, setSortOrder] = useState('asc')
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const [isPending, setIsPending] = useState(false);
    const [notificationsPending, setNotificationsPending] = useState(false)
    // pending state
    const [deletePending, setDeletePending] = useState(false)

    const deleteNotificationSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const deleteNotificationError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
        // Create an instance of Axios
        const api = axios.create({
            baseURL: `${base_url}`
        });
    
        // Set the authorization token for all requests
        api.interceptors.request.use((config) => {
            // Add your authorization token logic here
            const token = sessionStorage.getItem('token');
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });

    useEffect(() => {
        fetchData();
    },[]);

    const fetchData = async () => {
        setNotificationsPending(true)
        try {
            const response = await api.get(`${base_url}/notification/get-all-notifications/`);
            setNotifications(response.data.result);
            setNotificationsPending(false)
        } catch (error) {
            console.log(error);
        }
    };

    const handleDelete = (id) => {
        setDeletePending(true)
        api
            .post(`${base_url}/notification/delete-notification/${id}`)
            .then(function (response) {
                console.log(response.data);
                fetchData();
                deleteNotificationSuccess("Record successfully deleted");
                setDeletePending(false)
            })
            .catch(function (error) {
                console.log(error.response.data.message);
                deleteNotificationError("An problem occurred while trying to complete your request")
            });
    };

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    // Sort learning array based on sortOrder
    const sortedNotifications = sortOrder === 'asc' ? [...notifications] : [...notifications].reverse();

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedNotifications.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // modal content ==================================================================================================

    const addNotificationSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsPending(true)
        api.post(`${base_url}/notification/add-notification/`, {
            "subject": subject,
            "message": message
        })
            .then(function (response) {
                console.log(response.data)
                setSubject("")
                setMessage("")
                addNotificationSuccess("Notification was successfully created")
                fetchData()
                setIsPending(false)
            })
            .catch(function (error) {
                console.log(error.response.data.message);
            })
    }

    // =======================================================================================
    // Added by VM

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedNotifications.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(sortedNotifications.length / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(sortedNotifications.length / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };
    // end navigation options



    return (
        <>
            <div>
                {/* <ToastContainer /> */}
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi bi-list"></i> NOTIFICATIONS
                            <small className="text-secondary" style={{fontWeight:"400",fontSize:"smaller"}}> ({notifications.length})</small>

                        </h6>
                    </div>
                    <div className="flex-fill text-end">
                        <button
                            className="btn-custom"
                            data-bs-toggle="modal"
                            data-bs-target="#add-notification"
                        >
                            <i className="bi bi-plus-circle"></i> Add
                        </button>
                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <table className="table table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>Subject</th>
                            <th>Message</th>
                            <th>Entry Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notificationsPending ? (
                            <tr>
                                <td colSpan="4" className="text-center my-3">
                                    <div className="spinner-border spinner-border-lg text-custom"></div>
                                </td>
                            </tr>
                        ) : (
                            currentItems.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.subject}</td>
                                    <td>{item.message}</td>
                                    <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                    <td>
                                        {deletePending ? (
                                            <button className="btn-custom-sm disabled-btn" disabled>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        ) : (
                                            <button className="btn-custom-sm" onClick={() => handleDelete(item.notificationID)}>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>
                {/* Pagination */}
                {/* <div className="pagination">
                    {Array.from({ length: Math.ceil(sortedNotifications.length / itemsPerPage) }, (_, index) => (
                        <button
                            key={index}
                            className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div> */
                }

                {/* Commented out by VM */}
                {/* Pagination */}
                {/* <div className="pagination">
                    <div class="dropdown">
                        <button type="button" class="btn-custom dropdown-toggle" data-bs-toggle="dropdown">
                            Select Page
                        </button>
                        <ul class="dropdown-menu" style={{maxHeight:""}}>
                            {Array.from({ length: Math.ceil(sortedNotifications.length / itemsPerPage) }, (_, index) => (
                                <li>
                                    <button
                                        key={index}
                                        className={`${currentPage === index + 1 ? 'custom-link dropdown-button' : 'custom-link text-dark dropdown-button'}`}
                                        onClick={() => paginate(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div> */}

                {/* Added by VM */}
                <div className="pagination btn-group">
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>

                    {/* page numbered buttons */}
                    {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(sortedNotifications.length / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(sortedNotifications.length / itemsPerPage)}
                    >
                        Last
                    </button>
                </div>

            </div>
            {/* Modal data content */}
            <div className="modal fade" id="add-notification">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-plus-circle"></i> Add Notification</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group my-3">
                                        <span class="input-group-text input-group-text-custom"><i class="bi bi-pencil"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span class="input-group-text input-group-text-custom"><i class="bi bi-link"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message" required />
                                    </div>
                                    {
                                        isPending ?
                                            <button type="submit" className="btn-custom w-100 disabled-btn" disabled>
                                                <span>Processing </span><span className="spinner-border spinner-border-sm ms-2"></span>
                                            </button>
                                            :
                                            <button type="submit" className="btn-custom w-100">Submit</button>
                                    }
                                </form>
                            </div>
                        </div>

                        {/* <!-- Modal footer --> */}
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
            {/* End modal data content */}
        </>
    );
};

export default Notifications;

